// CardiovascularRespiratory
import { Grid, Box, Typography } from "@mui/material";
  import ImageSlideshow from "../../components/ImageSlideShow";
  import { ZoomInRounded } from "@mui/icons-material";
  import TransitionsModal from "../../components/modal/modal";
  import ImageSlider from "../../components/ImageSlider";
  import { useState } from "react";
import ContentLayout from "../../components/ContentLayout";

import cardio_dept_img1 from "../../assets/images/facilities/infrastructure/departments/cardio_Dept/cardio-img-1.jpg";
import cardio_dept_img2 from "../../assets/images/facilities/infrastructure/departments/cardio_Dept/cardio-img-2.jpg";
import cardio_dept_img3 from "../../assets/images/facilities/infrastructure/departments/cardio_Dept/cardio-img-3.jpg";
import cardio_dept_img4 from "../../assets/images/facilities/infrastructure/departments/cardio_Dept/cardio-img-4.jpg";
import cardio_dept_img5 from "../../assets/images/facilities/infrastructure/departments/cardio_Dept/cardio-img-5.jpg";
import cardio_dept_img6 from "../../assets/images/facilities/infrastructure/departments/cardio_Dept/cardio-img-6.jpg";
  
  type ImageType = {
    src: string;
    alt: string;
  };
  
  type DepartmentObject = {
    name: string;
    img: Array<ImageType>;
  };
  
  const DepartmentData: Array<DepartmentObject> = [
    {
      name: "Department of Cardiovascular & Respiratory",
      img: [
        { src: cardio_dept_img1, alt: "cardio_dept_img1" },
        { src: cardio_dept_img2, alt: "cardio_dept_img2" },
        { src: cardio_dept_img3, alt: "cardio_dept_img3" },
        { src: cardio_dept_img4, alt: "cardio_dept_img4" },
        { src: cardio_dept_img5, alt: "cardio_dept_img5" },
        { src: cardio_dept_img6, alt: "cardio_dept_img6" },
      ],
    }
  ];
  
  const CardiovascularRespiratory = () => {
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState("");
    const [sliderImages, setSliderImages] = useState<Array<ImageType>>();

    return (
      <>
        <ContentLayout>
          <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box sx={{ position: "relative" }} >
                  <ImageSlideshow
                    sx={{}}
                    images={DepartmentData[0]?.img as Array<ImageType>}
                    showCaption={false} showCount={false} />
                  <Box
                    sx={{
                      position: "absolute" as "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                    onClick={() => {
                      setTitle(DepartmentData[0]?.name);
                      setSliderImages(DepartmentData[0]?.img);
                      setOpen(true);
                    } }
                  >
                    <ZoomInRounded
                      sx={{
                        color: "#fdd025",
                        zIndex: 99,
                        fontSize: "4rem",
                        "&:hover": {
                          fontSize: "6rem",
                        },
                      }} />
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography  variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                    Cardiovascular and Respiratory Physiotherapy department at PES Modern College of Physiotherapy is dedicated to training skilled professionals who can optimize the respiratory and cardiovascular health of individuals across the lifespan.
                    You will gain a comprehensive understanding of the heart, lungs, and circulatory system, enabling you to assess, diagnose, and treat a wide range of conditions, from chronic obstructive pulmonary disease (COPD) and asthma to heart failure and post-operative cardiac care.
                    Our curriculum focuses on evidence-based practice, patient-centered care, and the importance of lifestyle modifications.
                    Through a combination of classroom learning, laboratory simulations, and clinical placements, you will develop the expertise to enhance breathing, exercise tolerance, and overall quality of life for patients with cardiopulmonary conditions
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                    Cardiorespiratory physiotherapy is an area of physiotherapy that specialises in the prevention, rehabilitation, and compensation of clients with diseases and injuries in the heart and lungs.
                    These conditions may manifest themselves as shortness of breath, persistent cough, increased work of breathing or the reduced ability to exercise. 
                </Typography>

                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                    In Hospital Physiotherapy people who suffer an acute heart or lung injury or require a heart or lung operation, are most often admitted directly to hospital.
                    People with chronic cardiorespiratory condition, who suffer a flare-up or exacerbation, may also require hospital admission.
                    While you are in hospital, your Physiotherapist will undertake a comprehensive assessment of your cardiorespiratory system, endurance and mobility and Cardiorespiratory Physiotherapy will then tailor a treatment program to your unique needs. 
                </Typography>

                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                    Outpatient Physiotherapy: Prevention or resolution of minor respiratory infections,<br/>
                    Thoracic Assessment and Mobilisations: to increase lung capacity & maintain Bronchial Hygiene,<br/>
                    Breathing Control Exercises: to increase capacities for optimise athletic performance.
                </Typography>
              </Grid>
          </Grid>
        </ContentLayout>

        {sliderImages && (
          <TransitionsModal
            open={open}
            setOpen={setOpen}
            title={title}
            children={<Grid item xs={12} margin={"auto"}>
              <Box sx={{ width: "75%", margin: "auto" }}>
                <ImageSlider images={sliderImages} />
              </Box>
            </Grid>} />
        )}
      </>
    );
  };
  
  export default CardiovascularRespiratory;
  